import { useRef, useState, useLayoutEffect } from 'react';

import useWindowSize from './useWindowSize';

function getOffsetRight(rect, width) {
  const right = width;

  const isOffset = getIsOffToRight(rect, width);

  if (!isOffset) {
    return 'unset';
  }

  const leftValue = right - rect.right;

  const left = leftValue - 25;

  return `${left}px`;
}

function getIsOffToRight(rect, width) {
  return rect.right > width;
}

function getIsOffToBottom(rect, height) {
  return rect.bottom > height;
}

function getIsInViewport(rect, width, height) {
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    !getIsOffToBottom(rect, height) &&
    !getIsOffToRight(rect, width)
  );
}

const useIsInViewport = () => {
  const { width, height } = useWindowSize();

  const elementRef = useRef(null);
  const [hasRecalculated, setHasRecalculated] = useState(false);
  const [state, setState] = useState({
    isInViewport: true,
    isOffToRight: false,
    offsetToRight: 0,
  });

  const recalculate = (updateState = true) => {
    if (hasRecalculated) {
      return;
    }

    const rect = elementRef.current.getBoundingClientRect();

    setState({
      isInViewport: getIsInViewport(rect, width, height),
      isOffToRight: getIsOffToRight(rect, width),
      offsetToRight: getOffsetRight(rect, width),
    });

    if (updateState) {
      setHasRecalculated(true);
    }
  };

  useLayoutEffect(() => {
    if (!elementRef.current) return undefined;

    recalculate(false);
  }, [width, height]);

  return {
    elementRef,
    recalculate,
    ...state,
  };
};

export default useIsInViewport;
